import { rivalTeams } from '../competition';
import type { SaveGame } from '../types';
import { TeamBadge } from './TeamBadge';

type BadgeSize = 'sm' | 'md' | 'lg';

/** Displays the persistent identity of the manager's club in both save modes. */
export function ClubBadge({ save, size = 'md' }: { save: Pick<SaveGame, 'clubName' | 'clubCrestId' | 'gameMode' | 'selectedTeamId'>; size?: BadgeSize }) {
  const crestId = save.clubCrestId ?? save.selectedTeamId ?? '';
  if (crestId.startsWith('draft_')) {
    const crest = crestId.replace('draft_', '');
    return <span className={`club-badge draft-crest-icon draft-crest-icon--${crest} draft-crest-icon--${size}`} title={`Escudo de ${save.clubName}`} aria-label={`Escudo de ${save.clubName}`} />;
  }

  const team = rivalTeams.find((candidate) => candidate.id === crestId || candidate.id === save.selectedTeamId);
  return <span className="club-badge"><TeamBadge name={save.clubName} imageUrl={team?.image_url} size={size} /></span>;
}
